<template>
  <div class="inspectionReport">
    <div class="inspectionContent">
      <div class="dataTitle">
        <van-icon
          class="hospiyalsArrowLeft"
          style="top: 16px;"
          name="arrow-left"
          @click="onBack"
          v-if="forwardingReport"
        />
        <div class="title">
          <div class="content action">检查报告</div>
          <div class="line">|</div>
          <div class="content" @click="toPortrait">数字影像</div>
          <div class="line" v-if="infoData && infoData[0].institution_id !== '06300007'">|</div>
          <div class="content" v-if="infoData && infoData[0].institution_id !== '06300007'" @click="toAttachment">附件</div>
          <div class="line" v-if="forwardingReport">|</div>
          <div class="content" @click="toForwarding" v-if="forwardingReport">转发报告</div>
        </div>
      </div>
      <div v-if="reportBool==1">
        <div class="dataList" v-if="report">
          <div class="itemContent" v-for="(item,index) in infoData" :key="index">
            <ul class="info" v-if="item.institution_id == '43600001'">
              <li class="header">
                <span v-if="item.type == 1" :style="{'paddingRight':item.local_institution_name.length>16?'30px':''}">{{item.local_institution_name}}</span>
                <div v-if="item.type == 2" style="text-align: center;">
                  <div style="font-size: 20px;">{{item.report_title}}</div>
                  <div style="font-size: 14px;">{{item.report_subtitle}}</div>
                  <div style="font-size: 16px;">{{item.exam_class}}检查报告单</div>
                </div>
                <span :id="`qrcode${index}`" class="white_QR"></span>
              </li>
              <li class="labelContent">
                <span class="label1">影像号：</span>
                <span class="content1">{{item.accession_num}}</span>
                <span class="label2">姓名：</span>
                <span class="content2">{{item.name}}</span>
              </li>
              <li class="labelContent">
                <span class="label1">检查时间：</span>
                <span class="content1">{{item.exam_datetime}}</span>
                <span class="label2">性别：</span>
                <span class="content2" v-if="item.sex == 'M'||item.sex == '男'">男</span>
                <span class="content2" v-if="item.sex == 'F'||item.sex == '女'">女</span>
              </li>
              <li class="labelContent">
                <span class="label1">申请科室：</span>
                <span class="content1">{{item.application_department}}</span>
                <span class="label2">年龄：</span>
                <span class="content2">{{item.age}}</span>
                
              </li>
              <li class="labelContent" v-if="item.institution_id ==='06300007'">
                <span class="label1">年龄：</span>
                <span class="content1">{{item.age}}</span>
                <span class="label2">申请科室：</span>
                <span class="content2">{{item.application_department}}</span>
              </li>
              <li class="labelContent" v-if="item.institution_id ==='06300007'">
                <span class="label1">住院号：</span>
                <span class="content1">{{item.hopitalized_no}}</span>
                <span class="label2">床号：</span>
                <span class="content2">{{item.bed_no}}</span>
              </li>
              <li class="labelContent" v-if="item.institution_id ==='06300007'">
                <span class="label1">检查部位：</span>
                <span class="content1" style="width:80%;text-align-last: auto;">{{item.exam_project}}</span>
              </li>
              <li class="labelContent" v-if="item.config_number&&item.insConfig">
                <!-- style="width:80%;text-align-last: auto;" -->
                <span class="label1">{{item.insConfig}}：</span>
                <span class="content1">{{item.config_number}}</span>
              </li> 
              <li class="labelContents" style="min-height:25px;">
                <!-- style="width:80%;text-align-last: auto;" -->
                <span class="label1">检查项目：</span>
                <span class="content1" style="width:100%;text-align-last: auto;word-wrap: break-word;">{{item.exam_project}}</span>
              </li>
              
              <li class="details">
                <div class="label" v-if="item.institution_id ==='06300007'">影像学所见：</div>
                <div class="label" v-else>检查所见：</div>
                <div class="details_info">
                  <!-- <span v-html="item.description"></span> -->
                  <span v-if="(/<[^>]+>/g).test(item.description)" v-html="item.description"></span>
                  <pre v-else>{{item.description}}</pre>
                </div>
                <div class="label" v-if="item.institution_id ==='06300007'">影像学意见：</div>
                <div class="label" v-else>诊断意见：</div>
                <div class="details_info">
                  <!-- <span v-html="item.impression"></span> -->
                  <span v-if="(/<[^>]+>/g).test(item.impression)" v-html="item.impression"></span>
                  <pre v-else>{{item.impression}}</pre>
                </div>
              </li>
              <li class="food">
                <span class="label">报告:</span>
                <span class="content">{{item.report_doctor_name}}</span>
                <span class="label">审核:</span>
                <span class="content">{{item.review_doctor_name}}</span>
                <span class="label">确认:</span>
                <span class="content">{{item.confirm_doctor_name}}</span>
              </li>
            </ul>
            <ul class="info" v-else>
              <li class="header">
                <span v-if="item.type == 1" :style="{'paddingRight':item.local_institution_name.length>16?'30px':'','textAlign': 'center'}">{{item.local_institution_name}}</span>
                <!-- <span v-if="item.type == 2">{{item.remote_institution_name}}</span> -->
                <div v-if="item.type == 2" style="text-align: center;">
                  <div style="font-size: 20px;">{{item.report_title}}</div>
                  <div style="font-size: 14px;">{{item.report_subtitle}}</div>
                  <div style="font-size: 16px;">{{item.exam_class}}检查报告单</div>
                </div>
                <span :id="`qrcode${index}`" class="white_QR"></span>
              </li>

              <li class="labelContent">
                <!-- <span class="label1">影像号：</span>
                <span class="content1">{{item.accession_num}}</span> -->
                <span class="label1">姓名：</span>
                <span class="content1">{{item.name}}</span>
                <span class="label2">检查项目：</span>
                <span class="content2">{{item.exam_project}}</span>
              </li>
              <li class="labelContent">
                <span class="label1">性别：</span>
                <span class="content1" v-if="item.sex == 'M'||item.sex == '男'">男</span>
                <span class="content1" v-if="item.sex == 'F'||item.sex == '女'">女</span>
                <span class="label2">检查时间：</span>
                <span class="content2">{{item.exam_datetime}}</span>
              </li>
              <li class="labelContent">
                <span class="label1">申请科室：</span>
                <span class="content1">{{item.application_department}}</span>
                <span class="label2">年龄：</span>
                <span class="content2">{{item.age}}</span>
              </li>
              <li class="labelContent">
                <span class="label1" v-if="item.config_number&&item.insConfig">{{item.insConfig}}：</span>
                <span class="content1" v-if="item.config_number&&item.insConfig">{{item.config_number}}</span>
              </li>
              <li class="details">
                <div class="label">检查所见：</div>
                <div class="details_info">
                  <span v-if="(/<[^>]+>/g).test(item.description)" v-html="item.description"></span>
                  <pre v-else>{{item.description}}</pre>
                  <!-- <span v-html="item.description"></span> -->
                </div>
                <div class="label">诊断意见：</div>
                <div class="details_info">
                  <span v-if="(/<[^>]+>/g).test(item.impression)" v-html="item.impression"></span>
                  <pre v-else>{{item.impression}}</pre>
                  <!-- <span v-html="item.impression"></span> -->
                </div>
              </li>
              <li class="food">
                <span class="label">报告:</span>
                <span class="content">{{item.report_doctor_name}}</span>
                <span class="label">审核:</span>
                <span class="content">{{item.review_doctor_name}}</span>
                <span class="label">确认:</span>
                <span class="content">{{item.confirm_doctor_name}}</span>
              </li>
            </ul>
            <div class="reportDate">
              <span>报告时间:{{item.report_datetime}}</span>
            </div>
          </div>
        </div>
        <div v-else-if="((!(infoData && infoData.length) || infoData) || (infoData && infoData.length && infoData[0].exam_status === 3 ) ) && !report" class="white_title">暂无报告</div>
        <van-collapse v-model="activeNames" v-if="report&&videoListArr.length">
          <van-collapse-item title="视频资料" name="1">
            <div class="showVideo">
              <video controls :src="currentVideoUrl" type="video/mp4"></video>
            </div>
            <div class="videoList">
              <div
                v-for="(item,index) in videoListArr"
                :key="index"
                @click="getCurrentVideoFn(item.video_url,index)"
              >
                <video
                  :class="isactiveVideo == index?'addclass' :'' "
                  :src="item.video_url"
                  :poster="item.image_url"
                  type="video/mp4"
                ></video>
              </div>
            </div>
          </van-collapse-item>
        </van-collapse>
        <div
          class="allReport"
          @click="toReportList"
          v-if="Storage.get('reportPermissions') != 1"
        >< 全部报告</div>
          <footer class="footer" v-if="report">
            <p style="padding: 0 10px;">以上资料仅供快捷浏览，报告内容以纸质报告为准，如需医学判断，请咨询医生。</p>
            <div class="outreach" @click="goView" v-if="reportAnnex != null">
              报告原件
              <img src="../../assets/arrow.png" alt />
            </div>
            <!-- <div class="outreach" @click="insurance">
              医疗保险
              <img src="../../assets/arrow.png" alt />
            </div> -->
            
             <div v-show="switch1 == 1 " class="outreach" @click="handleConfirm">
              报告结果咨询
              <img src="../../assets/arrow.png" alt />
            </div>
            <div class="outreach" @click="fundraising" v-if="infoData[0].institution_id !== '13740001'">
              大病众筹
              <img src="../../assets/arrow.png" alt />
            </div>
            <div class="reportReadBox">
              <van-button type="primary" class="reportRead" v-if="!examidStorage.includes(infoData[0].exam_id) && infoData[0].report_interpret == '1'"  @click="goReportRead('fromReport')">请医生解读报告</van-button>
              <wx-open-launch-weapp
                v-else-if="infoData[0].report_interpret == '1' && examidStorage.includes(infoData[0].exam_id)"
                id="launch-btn"
                appid="wx13a47ee9b472614f"
                :path='xcxurl'
                @launch="handleLaunch1"
                @error="handleError1"
              >
              <!-- /pages/home/index?scene=1&exam_id=`${infoData[0].exam_id}` -->
                <script type="text/wxtag-template">
                  <style>
                    .reportRead1 {
                      width: 234px;
                      height: 44px;
                      padding: 5px 0;
                      border-radius: 50px;
                      margin: 20px auto 0;
                      color: #fff!important;
                      font-size: 16px!important;
                      border: 1px solid rgb(19, 172, 193);
                      background-color: rgb(19, 172, 193);
                    }
                  </style>
                  <button class="reportRead1">请医生解读报告</button>
                </script>
              </wx-open-launch-weapp>
            </div>
          </footer>
        </div>
      </div>
      <div class="inspectionMontmorillonite" v-if="Montmorillonite">
        <div class="inspectionInputBox">
          <div class="inspectionInputBoxPrompt">提示</div>
          <div class="inspectionInputBoxContent">
            <div class="inspectionInputBoxContentTitle">请输入4位密码查看{{xxx}}检查报告</div>
            <div class="inspectionInputBoxContentPassword">
              输入密码：
              <input v-model="code" type="text" />
            </div>
          </div>
          <div class="inspectionInputBoxButton">
            <span @click="cencelMontmorillonite">确定</span>
          </div>
        </div>
      </div>
      <!-- 查看分享报告 关注公众号二维码浮层 -->
       <!-- getQueryString('id') == 'cnb518tkh0ou8lx8' 报告解读测试 检查隐藏 跳转第三方小程序 -->
      <div class="attentionQRCode" v-if="!forwardingReport && reportRead">
        <!-- <div class="attentionQRCode"> -->
        <div style="display:flex">
          <img class="logo" src="../../assets/login.png" alt />
          <p style="font-size:14px">中世康恺</p>
        </div>
        <p :style="{fontSize:'12px'}">本服务由数字影像云提供，可关注公众号进一步了解详情</p>
        <img class="QRCodeImg" src="../../assets/QRcode.png" @click="show = true" alt />
      </div>
    <!-- 二维码弹窗 -->
    <van-overlay :show="show" @click="show = false">
      <div class="wrapper">
        <!--@click.stop-->
        <div class="block">
          <img class="modelQRCodeImg" src="../../assets/QRcode.png" />
          <p :style="{fontWeight:'bold',margin:'0px'}">公众号：数字影像云</p>
          <p :style="{fontSize:'12px',color:'#707270',margin:'5px 0'}">长按识别</p>
        </div>
      </div>
    </van-overlay>
    <div id="mask" v-if="isMask">
      <img src="../../assets/mask.png" alt="">
    </div>
    <!-- 演示链接增加 ‘健康检查咨询’弹窗 -->
    <van-dialog v-model="isOpenModel" title="报告结果咨询" confirmButtonText="去咨询" confirm-button-color="#409eff" @confirm="handleConfirm">
      <van-icon name="cross" style="position: absolute;top: 15px;right: 15px;color:#909399;" @click="isOpenModel = false" />
      <div style="padding: 15px;line-height: 24px;text-align: center;">
        <img src="@/assets/zixun.jpg" style="width: 180px;height: 180px;" alt="">
      </div>
    </van-dialog>
    <!-- 检查详情报告解读 同意书弹窗 -->
    <van-dialog v-model="isOpenReadModel" title="三甲名医在线解读" :show-confirm-button="false">
      <van-icon name="cross" style="position: absolute;top: 15px;right: 15px;color:#909399;" @click="isOpenReadModel = false" />
      <div class="scrollBox">
        <div class="blocks">
          <p>✅支持所有检验和检查报告：核磁、CT、X线、血常规、尿常规、肾功、肝功、甲功等。</p>

          <p>✅支持咨询在线医生：饮食、运动和疾病预防等相关问题。</p>

          <p>👍专业、细致、耐心。</p>
          <!-- <div style="height:80px"></div> -->
           <div style="background: #fff;">
            <div style="margin: 10px 0;">
              <van-checkbox v-model="checked" shape="square" icon-size="12px" @change="changeHandle"/>
              <span style="margin-left:5px;color: rgb(19, 172, 193);">我已同意<span @click="goReadDetailModel()">《数字影像云报告解读服务知情同意书》</span></span>
            </div>
            <div style="width: 100%;"> 
              <!-- <van-button type="primary" class="reportRead" @click="handleLaunch2">报告解读</van-button> -->
              <van-button type="primary" v-if="!checked" @click="goReportRead1">开始解读</van-button>
              <wx-open-launch-weapp
                  id="launch-btn2"
                  appid="wx13a47ee9b472614f"
                  :path="xcxurl"
                  @launch="handleLaunch2"
                  @error="handleError2"
                  v-else
                >
                  <script type="text/wxtag-template">
                    <style>
                      .reportRead1 {
                        width: 234px;
                        height: 44px;
                        padding: 5px 0;
                        border-radius: 50px;
                        color: #fff!important;
                        font-size: 16px!important;
                        border: 1px solid rgb(19, 172, 193);
                        background-color: rgb(19, 172, 193);
                      }
                    </style>
                    <button class="reportRead1">开始解读</button>
                  </script>
                </wx-open-launch-weapp>
            </div>
           </div>
           
        </div>
      </div>
    </van-dialog>
    <van-dialog v-model="isOpenReadDetailModel" title="数字影像云报告解读服务知情同意书" :show-confirm-button="false">
      <van-icon name="cross" style="position: absolute;top: 15px;right: 15px;color:#909399;" @click="isOpenReadDetailModel = false" />
      <div class="scrollDetailBox">
        <div class="blocks">
          <!-- <div>《数字影像云报告解读服务知情同意书》</div> -->
          <p>尊敬的患者/患者家属：</p>
          <p>
            您好！感谢您选择使用中世康恺科技有限公司提供的“数字影像云”公众号服务中的“报告
            解读”功能。为保障您的合法权益，确保您充分了解该服务的相关情况，特向您告知如下内
            容：
          </p>
          <p class="subTitle">一、服务内容</p>
          <p>“数字影像云”公众号服务中的“报告解读”功能由重庆君子务本科技有限公司提供。当您
点击“报告解读”按钮时，将跳转至重庆君子务本科技有限公司提供的报告解读服务页面。
该服务旨在通过专业的技术手段和医学知识，对您的医学影像报告进行解读，帮助您更好地
理解报告内容及检查结果。</p>
          <p class="subTitle">二、数据安全与隐私保护</p>
          <p>1.中世康恺科技有限公司和重庆君子务本科技有限公司均高度重视您的个人信息安全与隐
            私保护。您的影像资料及报告信息将通过加密技术进行传输与存储，确保数据的安全性。</p>
          <p>2.您的个人信息及报告解读结果仅用于为您提供医疗服务及必要的医疗咨询，不会用于其他任何商业用途。</p>
          <p>3.在服务过程中，如需将您的报告解读结果共享给其他医疗机构或专业人士，将事先征得您的明确同意。</p>
          <p class="subTitle">三、风险与限制</p>
          <p>1.报告解读服务是基于现有的医学知识和技术手段提供的辅助性解读，不能替代专业医生
            的面诊意见。最终的诊断和治疗方案应以医生的专业判断为准。</p>
            <p>2.由于医学的复杂性和个体差异，报告解读结果可能存在一定的局限性。在某些情况下，
              可能需要进一步的检查或诊断以确认病情。</p>
          <p>3.如您在使用报告解读服务过程中遇到任何问题或对解读结果有疑问，应及时咨询专业医
            生。</p>
            <p class="subTitle">四、费用说明</p>
            <p>重庆君子务本科技有限公司提供的报告解读服务可能涉及一定的费用。具体收费标准及支付
              方式将在服务页面进行明确说明。您在使用该服务前应仔细阅读相关费用说明，并确认同意
              支付相应费用。</p>
            <p class="subTitle">五、同意与授权</p>
            <p>1.您已充分了解上述内容，自愿选择使用“数字影像云”公众号服务中的“报告解读”功
能，并同意中世康恺科技有限公司将您的影像资料及报告信息传输给重庆君子务本科技有限
公司进行解读。</p>
          <p>2.您授权重庆君子务本科技有限公司及其授权的专业人员对您的影像资料及报告进行解读，
            并将解读结果提供给您。</p>
          <p>请您在确认同意以上内容后，点击“同意”按钮以继续使用“报告解读”服务。如果您不同
            意上述内容，可以选择不使用该服务。</p>
          <div style="height:20px"></div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import Storage from "@/tools/storage";
import getQueryString from "@/tools/getUrlParams";
import portrait from "@/views/reportInfo/children/portrait";
import forwardingReport from "@/views/reportInfo/children/forwarding";
import attachment from "@/views/reportInfo/children/attachment";
import { Toast } from 'vant'
import {
  getReportByCode,
  getOneReport,
  getReportInfo,
  getVideo,
  getReportAnnex,
  getPayData,
  ready2pay,
  getSwitch,
  getSaveInterpretLog
} from "@/api/report";
import { ready2OutFilmPay } from "@/api/reportOuter";
import { wechatLogin } from "@/api/user";
import store from "@/store";
import QRCode from "qrcodejs2"; /* 生成二维码 */
import wx from "weixin-js-sdk";
import axios from "axios";
export default {
  name: "inspectionReport",
  components: { portrait, forwardingReport, attachment },
  data() {
    return {
      checked: true,
      isOpenReadModel: false,
      isOpenReadDetailModel: false,
      agreementContent: require('./agreement.js'),
      isOpenModel: false,
      xxx: Storage.get("makeReportLinkName"),
      infoData: [],
      Montmorillonite: false,
      code: "",
      forwardingReport: true,
      examId: true,
      report: false,
      show: false,
      activeNames: [],
      currentVideoUrl: "",
      isactiveVideo: 0,
      videoListArr: [],
      reportAnnex: null,
      reportBool: 1,
      isMask: false,
      isAnonymous: 0,
      isEncrypt: 0,
      yanshiWXUrl: '',
      switch1: 0,
      examidStorage: [],
      xcxurl: '',
      reportRead: true
    };
  },
  filters: {
    qzCode(id, url) {
      let text = url;
      let QrCodes = document.getElementById("qrcode" + id);
      let qrcode = new QRCode("qrcode", {
        width: 100,
        height: 100, // 高度
        text: text // 二维码内容
        // render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        // background: '#f0f'
        // foreground: '#ff0'
      });
      let obtainImg = QrCodes.getElementsByTagName("img");
      let obtainCanvas = QrCodes.getElementsByTagName("canvas");
      // console.info(obtainCanvas);
      obtainImg[0].style.width = 1 + "rem";
      obtainImg[0].style.height = 1 + "rem";
      obtainCanvas[0].style.width = 1 + "rem";
      obtainCanvas[0].style.height = 1 + "rem";
    }
  },
  
  methods: {
    goReadDetailModel() {
      this.isOpenReadDetailModel = true
    },
    handleLaunch1(e) {
      this.reportReadRecord(1)
      console.log('跳转成功', e.detail);
    },
    handleError1(e) {
      this.reportReadRecord(1)
      console.error('跳转失败', e.detail);
    },
    handleLaunch2(e) {
      const fromValue = Storage.get('fromValue')
      if(fromValue == 'fromList'){
        this.reportReadRecord(5)
      }else{
        this.reportReadRecord(2)
      }
      console.log('跳转成功', e.detail);
    },
    handleError2(e) {
      this.reportReadRecord(2)
      console.error('跳转失败', e.detail);
    },
    async reportReadRecord(type) {
      let res = await getSaveInterpretLog({
        id: this.infoData[0].exam_id,
        type,
        source: 1
      });
    },
    changeHandle(e) {
      console.log(e)
    },
    goReportRead(fromValue) {
      if(fromValue == 'fromReport'){
        Storage.set('fromValue', 'fromReport')
        this.reportReadRecord(1)
      }
      const examidStorage = (this.examidStorage.length && this.examidStorage) || []
      if (!examidStorage.some(item => String(item) === String(this.infoData[0].exam_id))) {
        this.examidStorage.push(String(this.infoData[0].exam_id)); // 保留原始类型
        Storage.set('examid', this.examidStorage)
        this.isOpenReadModel = true
      }else {
        this.isOpenReadModel = false
      }
    },
    goReportRead1() {
      Toast('请先勾选我已同意')
    },
    initSdkConfig() {
      axios
        .post("https://wechat.pacsonline.cn/wx_patient/api/getJsSdkConfig")
        .then(res => {
          wx.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ['scanQRCode'],
            openTagList: ['wx-open-launch-weapp']
          });
        });
    },
    async getPayData() {
      let res = await getPayData({
        institution_id: this.infoData[0].institution_id,
        exam_id: this.infoData[0].exam_id,
      })
      if(res){
        if(res.pay_status === '0'){//未支付
          console.log(this.infoData,'支付')
          this.isMask = true
          this.getWechatPay({ id: this.infoData[0].exam_id, openid: Storage.get("openid") })
        }else{
          this.isMask = false
        }
      }
      
    },
    wechatPay() {
      let _this = this;
      axios
        .post("https://wechat.pacsonline.cn/wx_patient/api/getJsSdkConfig")
        .then(res => {
          wx.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["chooseWXPay"]
          });
          wx.chooseWXPay({
            timestamp: _this.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
            nonceStr: _this.nonceStr, // 支付签名随机串，不长于 32 位
            package: _this.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
            signType: _this.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
            paySign: _this.paySign, // 支付签名
            success: function(res) {
              alert('支付成功')
              _this.isMask = false
              // _this.getAllReport();
              // 支付成功后的回调函数
            }
          });
        });
    },
    async getWechatPay(params) {
      let res = await ready2pay(params);
      if (res) {
        this.nonceStr = res.nonceStr;
        this.package = res.package;
        this.paySign = res.paySign;
        this.signType = res.signType;
        this.timeStamp = res.timeStamp;
        this.wechatPay();
      }
    },
    async getSwitchFetch(exam_id) {
      let res = await getSwitch({
        exam_id: exam_id
      });
      if (res) {
        this.yanshiWXUrl = res.url
        this.switch1 = res.switch
        if(res.switch == 1){
          this.isOpenModel = true
        }else{
          this.isOpenModel = false
        }
      }
    },
    handleConfirm() {
      window.open(this.yanshiWXUrl)
    },
    /* 判断是否有内容 */
    initial() {
      if (!!this.$route.query.short) {
        Storage.set("share", this.$route.query.short);
      }
      let url = window.location.href;
      // console.log(JSON.parse(Storage.get('share')) == null)
      // console.log(JSON.parse(Storage.get('share')))
      // console.log(typeof Storage.get('share'))
      let shar = JSON.parse(Storage.get("share")) == null;
      let smslink = this.$route.query.smslink == 1;
      if (shar && !(url.indexOf("report_id=") != -1) && !smslink) {
        let examId = JSON.parse(Storage.get("reportInfo")).length;
        if (!examId) {
          this.examId = false;
        }
        getReportInfo({
          exam_id: this.examId
            ? JSON.parse(Storage.get("reportInfo"))[0].exam_id
            : Storage.get("examId")
          // exam_id: JSON.parse(Storage.get('reportInfo'))[0].exam_id
        }).then(res => {
          if (res.length && res[0].id) {
            this.infoData = res;
            this.creatQrCode(res);
            if (res[0].exam_status == 9 || res[0].report_status == 9) {
              this.report = true;
            }
          } else {
            this.report = false;
          }
        });
      }
      //  else {
      //   this.report = true//
      //   this.noreport = true//医疗
      //   this.noreports = false//暂无报告
      // }
    },
    /* 二维码 */
    creatQrCode(data) {
      this.infoData = JSON.parse(Storage.get("reportInfo"));
      // let data = JSON.parse(Storage.get('reportInfo'))
      setTimeout(() => {
        this.$nextTick(() => {
          for (let i = 0; i < data.length; i++) {
            let text = data[i].qr_code;
            let QrCodes = document.getElementById("qrcode" + i);
            let qrcode = new QRCode(QrCodes, {
              width: 100,
              height: 100, // 高度
              text: text // 二维码内容
              // render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
              // background: '#f0f'
              // foreground: '#ff0'
            });
            let obtainImg = QrCodes.getElementsByTagName("img");
            let obtainCanvas = QrCodes.getElementsByTagName("canvas");
            // console.info(obtainCanvas);
            obtainImg[0].style.width = 1 + "rem";
            obtainImg[0].style.height = 1 + "rem";
            obtainCanvas[0].style.width = 1 + "rem";
            obtainCanvas[0].style.height = 1 + "rem";
          }
        });
      }, 1000);
    },
    insurance() {
      window.location.href = "http://leo.spread.newtank.cn/group0930";
    },
    fundraising() {
      window.location.href =
        "https://www.shuidichou.com/luban/f45t2je2sard/1?channel=ad_search_sem&source=app_zkwx";
    },
    toPortrait() {
      // this.$router.push({ path: "/reportInfo/portrait" });
      let url = window.location.href;
      let hostname = url.split('/#/')
      if(Storage.get("reportParams")){
        window.location.href = hostname[0]+'/#/reportInfo/portrait?'+ Storage.get("reportParams")
      }else{
        this.$router.push({ path: "/reportInfo/portrait"})
      }
    },
    toReportList() {
      this.$router.push({ path: "/reportList" });
    },
    toAttachment() {
      // this.$router.push({ path: "/reportInfo/attachment" });
      let url = window.location.href;
      let hostname = url.split('/#/')
      if(Storage.get("reportParams")){
        window.location.href = hostname[0]+'/#/reportInfo/attachment?'+ Storage.get("reportParams")
      }else{
        this.$router.push({ path: "/reportInfo/attachment"})
      }
    },
    onBack() {
      // this.$router.push({ path: '/filmQuery' })
      this.$router.go(-1);
    },
    toForwarding() {
      let url = window.location.href;
      let hostname = url.split('/#/')
      if(Storage.get("reportParams")){
        window.location.href = hostname[0]+'/#/reportInfo/forwarding?'+ Storage.get("reportParams")
      }else{
        this.$router.push({ path: "/reportInfo/forwarding"})
      }
      // this.$router.push({ path: "/reportInfo/forwarding" });
    },
    async cencelMontmorillonite() {
      console.log(Storage.get("share") == 1);
      let params;
      if (Storage.get("share") == 1) {
        params = {
          id: Storage.get("makeReportLinkId"),
          code: this.code,
          short: 1,
          isEncrypt: this.isEncrypt,
          isAnonymous: this.isAnonymous
        };
      } else {
        params = {
          id: Storage.get("makeReportLinkId"),
          code: this.code,
          isEncrypt: this.isEncrypt,
          isAnonymous: this.isAnonymous
        };
      }
      console.log(params)
      let res = await getReportByCode(params);
      if (res == null) {
        Storage.set("isShows", 1);
      } else {
        if (res.length && res[0].id) {
          Storage.set("reportInfo", res);
          Storage.set("studyId", res[0].study_id);
          this.infoData = res;
          this.report = true;
          this.Montmorillonite = false;
        } else {
          Storage.set("reportInfo", res);
          Storage.set("studyId", res[0].study_id);
          this.report = false;
          this.Montmorillonite = false;
        }
        if(getQueryString("id") == 'cnb518tkh0ou8lx9'){
          this.getSwitchFetch(res[0].exam_id)
        }
        Storage.set("isShows", 2);
      }
    },
    // async wechatLogin(reportId) {
    //   console.log(Storage.get('openid'))
    //   let that = this
    //   let params = { openid: Storage.get('openid') }
    //   let res = await wechatLogin(params)
    //   if (res) {
    //     store.dispatch('setToken', res.token)
    //     that.getOneReport()
    //   }
    // },
    async getOneReport() {
      let params = { id: Storage.get("reportId") };
      let res = await getOneReport(params);
      if (res) {
        this.report = true;
        let arr = [];
        arr.push(res);
        this.infoData = arr;
        Storage.set("reportInfo", arr);
        Storage.set("studyId", res.study_id);
        if(res.institution_id === '03060002'){
          this.getPayData()
        } else {
          this.isMask = false
        }
      }
    },
    // 获取视频列表
    async handleChange(exam_id) {
      this.videoListArr = [];
      this.currentVideoUrl = "";
      let res = await getVideo({
        exam_id: exam_id
      });
      if (res.length) {
        this.currentVideoUrl = res[0].video_url;
        this.videoListArr = res;
      }
    },
    getCurrentVideoFn(url, index) {
      console.log(url);
      this.currentVideoUrl = url;
      this.isactiveVideo = index;
    },
    async getReportAnnex() {
      let res = await getReportAnnex({exam_id: this.infoData[0].exam_id});
      this.reportAnnex = res
      // if(res){
      //   this.$router.push({ path: "/reportInfo/image" ,query: { url: this.reportAnnex.url, name: this.reportAnnex.name, code: this.reportAnnex.annex_class_code}});
      // }
    },
    goView() {
      // this.getReportAnnex(1)
      this.$router.push({ path: "/reportInfo/image" ,query: { url: this.reportAnnex.url, name: this.reportAnnex.name, code: this.reportAnnex.annex_class_code}});

    },
    getIsEncryptFn(isEncrypt){
      if(isEncrypt=== "0"){
        return false
      }else {
        return true
      }
    }

  },
  mounted() {
    this.infoData = JSON.parse(Storage.get("reportInfo"));
    this.initial();
    if (this.infoData) {
      if (this.infoData[0].exam_status == 9 || this.infoData[0].report_status == 9) {
        this.report = true;
      }
    } else {
      this.report = false;
    }
    // this.creatQrCode()
  },

  created() {
    let url = window.location.href;
    this.isEncrypt = this.$route.query.isEncrypt
    this.isAnonymous = this.$route.query.isAnonymous
    
    // this.handleChange()
    this.initSdkConfig()
    this.examidStorage = JSON.parse(Storage.get('examid')) || []
    this.infoData = JSON.parse(Storage.get("reportInfo"));
    this.getReportAnnex()
    // const fromValue = Storage.get('fromValue')
    // if(fromValue == 'fromList'){
    //   this.goReportRead('fromList')
    //   return
    // }
    if (url.indexOf("report_id=") != -1) {
      let openid = getQueryString("openid");
      let examId = getQueryString("exam_id");
      let reportId = getQueryString("report_id");
      Storage.set("openid", openid);
      Storage.set("reportId", reportId);
      Storage.set("examId", examId);
      // this.wechatLogin()
      this.getOneReport();
      return;
    }
    if (url.indexOf("short=1") != -1 || url.indexOf("smslink=1") != -1) {
      if (url.indexOf("short=1") != -1 && url.indexOf("id=") != -1) {
        let str = url.match(/id=(\S*)&short/)[1];
        Storage.set("makeReportLinkId", str);
        let string = url.indexOf("name=");
        let names = url.substring(string);
        let num = names.indexOf("=");
        let name = names.substring(num + 1);
        let nameValue = name.split('&')[0]
        this.xxx = decodeURI(nameValue) + "的";
        Storage.set("makeReportLinkName", decodeURI(nameValue));
      } else if (url.indexOf("smslink=1") != -1 && url.indexOf("id=") != -1) {
        if (url.indexOf("?") != -1) {
          Storage.set("reportParams", url.split('?')[1]);
        }
        Storage.set("makeReportLinkId", this.$route.query.id);
        this.xxx = "";
      }
      console.log((Storage.get("isShows") == 1 || Storage.get("isShows") == null),this.getIsEncryptFn(this.isEncrypt))
      if ((Storage.get("isShows") == 1 || Storage.get("isShows") == null) && this.getIsEncryptFn(this.isEncrypt) ) {
        this.Montmorillonite = true;
      } else {
        this.Montmorillonite = false;
        if(!this.getIsEncryptFn(this.isEncrypt)){
          this.cencelMontmorillonite()
        }
      }
      Storage.set("reportPermissions", 1);
    } else {
      this.Montmorillonite = false;
      let examId = JSON.parse(Storage.get("reportInfo"));
      let exam_id = examId ? examId[0].exam_id : Storage.get("examId");
      if (exam_id) {
        this.handleChange(exam_id);
      }
    }
    // && getQueryString("id") != 'cnb518tkh0ou8lx9' 公众号演示
    // cnb518tkh0ou8lx8  报告解读测试
    console.log(getQueryString("id") != 'cnb518tkh0ou8lx9') //true 
    console.log(getQueryString("id") != 'cnb518tkh0ou8lx8') //false
    if (Storage.get("reportPermissions") && getQueryString("id") != 'cnb518tkh0ou8lx9') {
      this.forwardingReport = false;
    }
    if (getQueryString("id") == 'cnb518tkh0ou8lx8') {
      this.reportRead = false;
    }
    const scene = this.infoData[0].scene || '1'
    this.xcxurl = '/pages/home/index?scene='+ scene +'&exam_id=' + this.infoData[0].exam_id
  }
};
</script>
<style lang="sass" scoped>
@import "../../style/reportInfo/index.css"
</style>
<style scoped>
.van-checkbox {
  display: inline-block!important;
}
.reportReadBox {
  width: 100%;
  text-align: center;
  position: fixed;
  bottom: 10px;
}
.reportRead {
  width: 50%!important;
  margin-top: 20px;
  font-size: 16px!important;
}
.van-button--primary{
  border: 1px solid rgb(19, 172, 193);
  background-color: rgb(19, 172, 193);
}
.van-button__text{
  color: #fff!important;
}
.white_title {
  height: 100vh;
  line-height: 100vh;
  font-size: 20px;
  text-align: center;
}
.header {
  position: relative;
  padding: 15px 0!important;
  font-weight: 500;
}
.white_QR {
  position: absolute;
  top: 0.4rem;
  right: 0;
}
.attentionQRCode .logo {
  width: 26px;
  height: 26px;
  display: inline-block;
  margin-right: 8px;
}
.attentionQRCode p {
  margin: 0;
}
.attentionQRCode .QRCodeImg {
  width: 80px;
  height: 80px;
  position: absolute;
  right: 25px;
  bottom: 40px;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 16px;
}
.block {
  width: 240px;
  height: 240px;
  background-color: #fff;
  text-align: center;
}
.wrapper .modelQRCodeImg {
  width: 150px;
  height: 150px;
  margin-top: 20px;
}
/* 视频 */
.showVideo {
  text-align: center;
}
.showVideo video {
  width: 100%;
  height: 170px;
}
.videoList {
  width: 90%;
  height: 70px;
  background: #000;
  display: flex;
  align-items: center;
  margin: 10px auto 0;
  overflow-x: scroll;
  border-radius: 10px;
  padding: 0 10px;
}
.videoList div {
  display: flex;
  align-items: center;
  justify-content: center;
}
.videoList video {
  width: 100px;
  height: 52px;
  margin-right: 10px;
  border-radius: 5px;
  cursor: pointer;
}
.addclass {
  width: 148px;
  height: 88px;
  border: 3px solid #8587fe;
}
.van-collapse-item >>> .van-cell {
  border-radius: 0rem !important;
  padding-left: 28px;
  font-size: 17px;
  color: #000;
}
.van-collapse-item >>> .van-cell__title {
  padding: 0 !important;
}
.content2 {
  width: 90px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
#mask{
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  z-index: 9999;
  /* background-color: rgb(255, 255, 255, .1);
  box-shadow: 0 25px 45px rgb(0 0 0 / 10%);
  -webkit-backdrop-filter: blur(9px);
  -moz-backdrop-filter: blur(9px);
  -ms-backdrop-filter: blur(9px);
  backdrop-filter: blur(9px); */
}
#mask img{
  width: 100vw;
  height: 100vh;
}
.details_info pre{
  word-wrap: break-word;
  white-space: pre-wrap;
  margin: 0;
}
.van-dialog .van-icon{
  color: #909399!important;
}
.scrollBox {
  width: 80%;
  /* height: 250px; */
  margin: 0 auto;
  padding: 20px;
  background: #ffffff;
}
.scrollDetailBox {
  width: 80%;
  height: 300px;
  overflow-y: scroll;
  margin: 0 auto;
  padding: 20px;
  background: #ffffff;
}
.blocks::-webkit-scrollbar {
  display: none;
}
.blocks {
  height: 100%;
  border-radius: 10px;
  /* overflow: auto;
  -webkit-overflow-scrolling: touch; */
  /* padding: 10px; */
}
.blocks div {
  font-size: 14px;
  text-align: center;
  font-weight: bold;
}
.blocks p {
  text-align: left;
  text-indent: 2em;
}
.blocks .subTitle {
  font-weight: bold;
}
</style>

